export default "__VITE_ASSET__O56sfrfg__"